// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-footer[data-v-b724c290]{display:flex;justify-content:space-between;padding:0 2rem;z-index:1000;background:#333!important}.main-footer .load-more[data-v-b724c290]{margin:auto 0;background:#ffcd1c;color:#333}.main-footer .load-more[data-v-b724c290]:focus{outline:none}", ""]);
// Exports
module.exports = exports;
